angular.module('core')
  .service('dblStandardsFactoryService', [function() {
        function createCluster(clusterRecord) {
            // Some ASTs don't have descriptive cluster names
            // TODO: more reliable way to do this from the data, or do it on
            // back end.
            var label = clusterRecord.name !== '---' ? clusterRecord.name : undefined;

            var edexCluster = {
                name: clusterRecord.name,
                label: label,
                description: clusterRecord.description,
                standards: []
            };

            return edexCluster;
        }

        function createDomain(domainRecord) {
            var edexDomain = {
                name: domainRecord.name,
                code: domainRecord.code,
                description: domainRecord.description,
                standardsCompleted: domainRecord.standards_completed,
                standardsCount: domainRecord.standards_count,
                clusters: [],
                standards: []
            };

            return edexDomain;
        }

        function createStandard(standardRecord, domain, useShortDescriptionLabel) {
            var label = useShortDescriptionLabel ? standardRecord.short_description : standardRecord.name;

            var edexStandard = {
                domain: domain,
                name: standardRecord.name,
                label: label,
                code: standardRecord.code,
                totals: standardRecord.totals,
                description: standardRecord.description,
                short_description: standardRecord.short_description, // for use in standards modal
                shortDescription: standardRecord.short_description,
                percentComplete: standardRecord.percent_complete,
                proficiencyStatus: standardRecord.proficiency_status
            };

            return edexStandard;
        }

        /**
         * Create cluster and standard objects from the given cluster records.
         * Creates a flattened list of all the standards from the clusters.
         *
         **/
        function createStandardsForClusters (clusterRecords, useShortDescriptionLabel) {
            var clustersAndStandards = {
                clusters: [],
                standards: []
            };

           _.each(clusterRecords, function (clusterRecord) {
                var cluster = createCluster(clusterRecord);
                clustersAndStandards.clusters.push(cluster);

                _.each(clusterRecord.standards, function (standardRecord) {
                    var standard = createStandard(standardRecord, clustersAndStandards, useShortDescriptionLabel);

                    cluster.standards.push(standard);
                    clustersAndStandards.standards.push(standard);
                });
            });

            return clustersAndStandards;
        }

        function createStandardsLevels (levelRecords, useShortDescriptionLabel) {

            _.each(levelRecords, function (levelRecord) {
                var domains = [];

                _.each(levelRecord.domains, function (domainRecord) {
                    var domain = createDomain(domainRecord);
                    domains.push(domain);

                    _.each(domainRecord.clusters, function (clusterRecord) {
                        var cluster = createCluster(clusterRecord);
                        domain.clusters.push(cluster);

                        _.each(clusterRecord.standards, function (standardRecord) {
                            var standard = createStandard(standardRecord, domain, useShortDescriptionLabel);

                            cluster.standards.push(standard);
                            domain.standards.push(standard);
                        });
                    });
                });

                levelRecord.domains = domains;
            });

            return levelRecords;
        }

        this.createStandardsForClusters = createStandardsForClusters;
        this.createStandardsLevels = createStandardsLevels;
    }
]);
